import Text from 'components/Text/Text';
import React, { useCallback } from 'react';
import { Form } from 'antd';
import Button from 'components/Button/Button';
import { TTypeOfCreateGameDeveloperModalWindow } from '../createDeveloperModalContext/createDeveloperModalState/createDeveloperModalContext';
import style from './BtnBlock.module.scss';

interface IBtnBlock {
	changeTypeOfModalWindow: (value: TTypeOfCreateGameDeveloperModalWindow) => void;
}

const BtnBlock: React.FC<IBtnBlock> = ({ changeTypeOfModalWindow }) => {
	const handleCancel = useCallback(() => {
		changeTypeOfModalWindow('toConfirmFieldsClearing');
	}, [changeTypeOfModalWindow]);

	return (
		<Form.Item>
			<div className={style.btnWrapper}>
				<Button className={style.cancelBtn} theme="secondary" onClick={handleCancel}>
					<Text translationNameSpace="form" translationKey="cancelButton" asFragment={true} />
				</Button>
				<Button className={style.saveBtn} theme="primaryBlue" type="submit">
					<Text translationNameSpace="form" translationKey="saveButton" asFragment={true} />
				</Button>
			</div>
		</Form.Item>
	);
};

export default React.memo(BtnBlock);
